import InputField from 'components/Global/InputField';
import SelectFieldWithMap from 'components/Global/SelectFieldWithMap';

import { useSelector } from 'react-redux';
import BlueMappin from 'icons/mappin-icon-blue.svg';
import CheckboxField from 'components/Global/CheckboxField';

import { addDays, format } from 'date-fns';

const MutableFormComponent = ({
  item,
  index,
  areaCharterData,
  allAreaCharter,
  setAllAreaCharter,
  rentalLocation,
  locationData,
  boundingBoxLocation,
  disable,
  sameLocationCheck,
  startDate,
}) => {
  const { dataZone } = useSelector((state) => state.shuttleAirport);

  const changeLocationHandler = (locationRent, type) => {
    if (allAreaCharter?.length === 0) return;

    if (type === 'start') {
      const startLocation = {
        id: locationRent.id,
        name: locationRent.label ?? locationRent?.name,
        lat: locationRent.y,
        lng: locationRent.x,
        coord: [locationRent.y, locationRent.x],
      };

      const newArrayAllAreaCharter = [...allAreaCharter].map((area, idx) => {
        if (idx === index) {
          return {
            ...area,
            date: format(addDays(startDate, idx), 'yyyy-MM-dd').toString(),
            pickup_location_name: locationRent.label ?? locationRent?.name,
            pickup_zone_lat: +locationRent.y,
            pickup_zone_long: +locationRent.x,
            startLocation,
            ...(area.sameLocation && {
              endLocation: startLocation,
              dropoff_location_name: locationRent.label ?? locationRent?.name,
              drop_off_zone_lat: +locationRent.y,
              drop_off_zone_long: +locationRent.x,
            }),
          };
        }

        return area;
      });

      setAllAreaCharter(newArrayAllAreaCharter);
      return;
    }

    if (type === 'end') {
      const endLocation = {
        id: locationRent.id,
        name: locationRent.label ?? locationRent?.name,
        lat: locationRent.y,
        lng: locationRent.x,
        coord: [locationRent.y, locationRent.x],
      };

      const newArrayAllAreaCharter = [...allAreaCharter].map((area, idx) => {
        if (idx === index) {
          return {
            ...area,
            date: format(addDays(startDate, idx), 'yyyy-MM-dd').toString(),
            dropoff_location_name: locationRent.label ?? locationRent?.name,
            drop_off_zone_lat: +locationRent.y,
            drop_off_zone_long: +locationRent.x,
            endLocation,
            sameLocation: false,
          };
        }

        return area;
      });

      setAllAreaCharter(newArrayAllAreaCharter);
      return;
    }
  };

  const changeCheckboxHandler = (e) => {
    if (!allAreaCharter?.length) return;

    const newArrayAllAreaCharter = [...allAreaCharter].map((area, idx) => {
      if (idx === index) {
        return {
          ...area,
          date: format(addDays(startDate, idx), 'yyyy-MM-dd').toString(),
          sameLocation: e.target.checked,
          ...(e.target.checked === true
            ? {
                endLocation: area.startLocation,
                dropoff_location_name: area.pickup_location_name,
                drop_off_zone_lat: area.pickup_zone_lat,
                drop_off_zone_long: area.pickup_zone_long,
              }
            : {
                endLocation: undefined,
                drop_off_zone_lat: '',
                drop_off_zone_long: '',
                dropoff_location_name: '',
              }),
        };
      }

      return area;
    });

    return setAllAreaCharter(newArrayAllAreaCharter);
  };

  const changeDetailLocationHandler = (detailLocationRent, type) => {
    if (!allAreaCharter?.length) return;

    if (type === 'start') {
      const newArrayAllAreaCharter = [...allAreaCharter].map((area, idx) => {
        if (idx === index) {
          return {
            ...area,
            date: format(addDays(startDate, idx), 'yyyy-MM-dd').toString(),
            detail_pickup_location: detailLocationRent,
          };
        }

        return area;
      });
      return setAllAreaCharter(newArrayAllAreaCharter);
    }

    if (type === 'end') {
      const newArrayAllAreaCharter = [...allAreaCharter].map((area, idx) => {
        if (idx === index) {
          return {
            ...area,
            date: format(addDays(startDate, idx), 'yyyy-MM-dd').toString(),
            detail_drop_off_location: detailLocationRent,
          };
        }

        return area;
      });

      return setAllAreaCharter(newArrayAllAreaCharter);
    }
  };

  const changeRentalAreaHandler = (e) => {
    if (!allAreaCharter) return;

    const newArrayAllAreaCharter = [...allAreaCharter].map((area, idx) => {
      if (idx === index) {
        return {
          ...area,
          date: format(addDays(startDate, idx), 'yyyy-MM-dd').toString(),
          detail_driving_location: e.target.value,
        };
      }

      return area;
    });

    return setAllAreaCharter(newArrayAllAreaCharter);
  };

  return (
    <div className="mutable-form">
      {sameLocationCheck && (
        <CheckboxField
          className="mutable-form__check-location"
          variants="primary"
          label="Lokasi sama seperti Pick Up"
          checked={areaCharterData?.sameLocation}
          htmlfor={`lokasi-sama-${item}`}
          onChange={changeCheckboxHandler}
          disable={disable}
        />
      )}

      <SelectFieldWithMap
        label="Pick Up"
        htmlFor={`pickup-location-${item}`}
        placeholder="Pilih Lokasi"
        iconUrl={BlueMappin}
        value={areaCharterData?.startLocation?.name ?? ''}
        setValue={(item) => changeDetailLocationHandler(item, 'start')}
        centerCoord={locationData?.latlng}
        positionCoord={areaCharterData?.startLocation?.coord || [0, 0]}
        onClick={(item) => changeLocationHandler(item, 'start')}
        showMap={rentalLocation?.name}
        mapBounds={locationData?.bounds}
        dataAirportTransferSpecial={dataZone?.shuttle}
        boundingBoxLocationAirportTransferSpecial={boundingBoxLocation}
        airportTransferSwitch
        disable={disable}
      />

      <SelectFieldWithMap
        label="Drop Off"
        htmlFor={`dropoff-location-${item}`}
        placeholder="Pilih Lokasi"
        iconUrl={BlueMappin}
        value={areaCharterData?.endLocation?.name ?? ''}
        setValue={(item) => changeDetailLocationHandler(item, 'end')}
        centerCoord={locationData?.latlng}
        positionCoord={areaCharterData?.endLocation?.coord || [0, 0]}
        onClick={(item) => changeLocationHandler(item, 'end')}
        showMap={rentalLocation?.name}
        mapBounds={locationData?.bounds}
        dataAirportTransferSpecial={dataZone?.shuttle}
        boundingBoxLocationAirportTransferSpecial={boundingBoxLocation}
        airportTransferSwitch
        disable={disable}
      />

      <InputField
        label="Detail Lokasi Pick Up"
        htmlFor={`detail-lokasi-pickup-${item}`}
        placeholder="Masukkan Detail Lokasi Pick Up"
        value={areaCharterData?.detail_pickup_location}
        onChange={(e) => changeDetailLocationHandler(e.target.value, 'start')}
        disable={disable}
      />

      <InputField
        label="Detail Lokasi Drop Off"
        htmlFor={`detail-lokasi-dropoff-${item}`}
        placeholder="Masukkan Detail Lokasi Drop Off"
        value={areaCharterData?.detail_drop_off_location}
        onChange={(e) => changeDetailLocationHandler(e.target.value, 'end')}
        disable={disable}
      />

      <InputField
        label="Rental Area"
        htmlFor={`rental-area-${item}`}
        placeholder="Masukan Rental Area"
        className="rental-area"
        value={areaCharterData?.detail_driving_location}
        onChange={changeRentalAreaHandler}
        disable={disable}
      />
    </div>
  );
};

export default MutableFormComponent;
